// extracted by mini-css-extract-plugin
export default {"hr":"Hr_hr__vTcvA","top_margin":"Hr_top_margin__G+B5W","bottom_margin":"Hr_bottom_margin__1-SMT","light":"Hr_light__dgEfP"};